<div class="container well">
    <div class="well-title">
        <div class="col-md-12">Zonal Templates</div>
    </div>

    <div class="col-md-12" style="margin-top: 15px">
        <nz-tabs>
            <nz-tab nzTitle="Zonal Templates">
                <div nz-row nzJustify="space-between" nzAlign="middle" style="margin-bottom: 12px">
                    <div nz-col>
                        <nz-input-search nzEnterButton="Search" (nzSearch)="onSearch()" style="width: 320px">
                            <input nz-input placeholder="Search by name" [(ngModel)]="searchValue" />
                        </nz-input-search>
                        <button nz-button (click)="clearSearch()" style="margin-left: 8px">Clear</button>
                    </div>
                    <div nz-col>
                        <a nz-button nzType="primary" [routerLink]="['/configure/zonaltemplatecreate']"
                            >Create Template</a
                        >
                    </div>
                </div>

                <nz-table
                    #templateTable
                    [nzData]="templates"
                    [nzLoading]="loading"
                    [(nzPageSize)]="pageSize"
                    [(nzPageIndex)]="pageIndex"
                    [nzPageSizeOptions]="pageSizeOptions"
                    [nzShowSizeChanger]="true">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Document Type</th>
                            <th nzWidth="80px">Edit</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (template of templateTable.data; track template) {
                            <tr>
                                <td>{{ template.ZonalTemplateName }}</td>
                                <td>{{ template.DocumentTypeName }}</td>
                                <td>
                                    <a
                                        nz-button
                                        nzType="link"
                                        [routerLink]="['/configure/zonaltemplateedit']"
                                        [queryParams]="{templateId: template.ZonalTemplateID}">
                                        <span nz-icon nzType="edit"></span>
                                    </a>
                                </td>
                            </tr>
                        }
                    </tbody>
                </nz-table>
            </nz-tab>

            <nz-tab nzTitle="Failed Templates">
                <nz-table
                    #failedTable
                    [nzData]="failedTemplates"
                    [nzLoading]="failedLoading"
                    [(nzPageSize)]="failedPageSize"
                    [(nzPageIndex)]="failedPageIndex"
                    [nzShowSizeChanger]="true">
                    <thead>
                        <tr>
                            <th>Scan Document</th>
                            <th>Scan Time</th>
                            <th nzWidth="160px">Create Template</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (failed of failedTable.data; track failed) {
                            <tr>
                                <td>{{ failed.ScanDocumentID }}</td>
                                <td>{{ failed.ScanTime | date: "medium" }}</td>
                                <td>
                                    <a
                                        nz-button
                                        nzType="link"
                                        [routerLink]="['/configure/zonaltemplatefailedcreate']"
                                        [queryParams]="{scanDocumentId: failed.ScanDocumentID}">
                                        Create Template
                                    </a>
                                </td>
                            </tr>
                        }
                    </tbody>
                </nz-table>
            </nz-tab>
        </nz-tabs>
    </div>
</div>
